import { TealiumButton } from "./TealiumButton/components/TealiumButton/TealiumButton.js";
import { TealiumIrisUIButton } from "./TealiumIrisUIButton/components/TealiumIrisUIButton/TealiumIrisUIButton.js";
import { TealiumLink } from "./TealiumLink/components/TealiumLink/TealiumLink.js";
export {
  TealiumButton,
  TealiumIrisUIButton,
  TealiumLink
};
//# sourceMappingURL=components.js.map
